import { useEffect, useState } from 'react'
import { ProjectsApi } from '../../../../api/projectApi'
import { toastMsg } from '../../../../components/Toast/toastMsg'
import { IUserDetail } from '../../../../types/user'
import * as constants from '../../actions/constants'
import { IProject } from '../../types/project'

// Loads its own list instead of the shared Redux `projects`, which holds whatever page the
// project list fetched last (often only the archived projects), see issue #134.
export const useCloneSourceProjects = (enabled: boolean): IProject[] => {
  const [projects, setProjects] = useState<IProject[]>([])
  useEffect(() => {
    if (!enabled) return
    ProjectsApi.getProjects({ no_pagination: 'true' })
      .then((response) => setProjects(response.filtered || []))
      .catch((error) => toastMsg(error.response?.data?.message ?? error.message, constants.GET_PROJECTS, 'error'))
  }, [enabled])
  return projects
}

// Projects of the wizard's kind the user may see, active ones first; the stable sort keeps the API's name order.
export const cloneSourceProjects = (projects: IProject[], user: IUserDetail, serviceProvider: boolean): IProject[] => {
  const employeeId = user.employee ? +user.employee.id : undefined
  return projects
    .filter((p) => (p.type === 'service_provider') === serviceProvider)
    .filter((p) => user.is_superuser || p.permissions === 'open' || p.employees.some((e) => +e.id === employeeId))
    .sort((a, b) => +b.active - +a.active)
}

export const toCloneProjectOptions = (projects: IProject[], selectedId?: number | string) =>
  projects.map((p) => ({
    key: +p.id,
    value: +p.id,
    text: p.active ? p.name : `${p.name} (archived)`,
    disabled: selectedId !== undefined && +selectedId === +p.id,
  }))
